import { Text } from 'react-native-paper';
import useFormStyle from '@/components/Styles/useFormStyle';
import { useGlobalSearchParams, useRouter } from 'expo-router';
import ScreenMargin from '@/components/ScreenMargin';
import { useForm } from 'react-hook-form';
import {
  UpdatePatientMutationVariables,
  useGetPatientQuery,
  useUpdatePatientMutation,
} from '@/data/data';
import { useUserContext } from '@/components/Auth/UserContext';
import { useState } from 'react';
import Form from '@/components/Form/Form';
import { View } from 'react-native';
import FTextInput from '@/components/Form/TextInput';
import BaseContainer from '@/components/BaseContainer';
import DatePickerInput from '@/components/Form/DatePickerInput';
import { AvailableValidationRules } from '@/components/Form/validation';
import FormSectionFooter from '@/components/Form/FormSectionFooter';
import ObjectHelper from '@/utils/ObjectHelper';
import {useTranslation} from "react-i18next";

const MajPatientPage = () => {
  const { detail } = useGlobalSearchParams();

  const { data: patient } = useGetPatientQuery({
    variables: {
      id: detail,
    },
    fetchPolicy: 'network-only',
  });

  const { user } = useUserContext();
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const [updatePatient] = useUpdatePatientMutation();
  const form = useForm<UpdatePatientMutationVariables>();

  const styles = useFormStyle();

  return (
    <ScreenMargin>
      <BaseContainer withScrollView={'keyboardAware'}>
        <Text style={styles?.headerForm}>{t('Mettre à jour un patient')}</Text>

        <Form<UpdatePatientMutationVariables>
          {...form}
          defaultValues={ObjectHelper.createDateValues(patient?.patientByPk, 'birthday')}
        >
          <View style={styles?.bodyForm}>
            <View style={styles?.groupForm}>
              <Text style={styles?.titleGroupForm}>{t('Données')}</Text>
              <FTextInput
                name={'nom'}
                label={t('Nom')}
                withMargin={false}
                containerStyle={styles.input2Col}
                validators={[AvailableValidationRules.required]}
              />
              <FTextInput
                name={'prenom'}
                label={t('Prénom')}
                withMargin={false}
                containerStyle={styles.input2Col}
                validators={[AvailableValidationRules.required]}
              />
              <DatePickerInput
                name={'birthday'}
                label={t('Date de naissance')}
                withMargin={false}
                containerStyle={styles.input2Col}
                validators={[AvailableValidationRules.required]}
              />
            </View>
          </View>
          <View style={styles?.footerForm}>
            <FormSectionFooter
              saveLoading={loading}
              saveDisabled={loading}
              onPress={form.handleSubmit(async (data) => {
                setLoading(true);
                if (user) {
                  await updatePatient({
                    variables: {
                      data,
                      id: detail,
                    },
                    fetchPolicy: 'network-only',
                  });
                }
                setLoading(false);
                router.back();
              })}
            />
          </View>
        </Form>
      </BaseContainer>
    </ScreenMargin>
  );
};

export default MajPatientPage;
